import { render } from "./eduTeamLesson.vue?vue&type=template&id=a3de4714&scoped=true"
import script from "./eduTeamLesson.vue?vue&type=script&lang=js"
export * from "./eduTeamLesson.vue?vue&type=script&lang=js"

import "./eduTeamLesson.vue?vue&type=style&index=0&id=a3de4714&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3de4714"]])

export default __exports__